import { http } from 'services/http';
import type { CargosToTripReq, CargoTripRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { CARGO_ITEMS_MANY, CARGO_TRIPS_MANY, TRIP_GET_ONE } from '../query-keys.ts';

interface IAddCargoToTripValue extends CargosToTripReq {
  tripId: number;
  updatedCargoId?: number;
}

export const useAddCargoToTrip = () => {
  return useMutationBase<CargoTripRes[], unknown, IAddCargoToTripValue>({
    mutationFn: async (variables) => {
      const res = await http.post<CargoTripRes[]>(`/v1/trips/${variables.tripId}/cargo-trips`, {
        cargoIds: variables.cargoIds,
        cargoItemIds: variables.cargoItemIds,
      });

      return res.data;
    },
    invalidateCallback: (_, { tripId, updatedCargoId }) => {
      const keys = [
        [TRIP_GET_ONE, tripId],
        [CARGO_TRIPS_MANY, tripId],
      ];

      if (updatedCargoId) keys.push([CARGO_ITEMS_MANY, updatedCargoId]);

      return keys;
    },
  });
};
